import React, { useState, useEffect, useRef } from 'react';
import SkeletonImage from '../Skeleton/skeleton-image-component';
import useLambdaImage from '../../Hooks/useImage';

const Image = ({
    src,
    alt,
    width,
    quality = 25,
    className = '',
    wrapperClassName = '',
    useSekeleton = true,
    onLoad,
    objectFit = 'cover',
    eager = false,       // eager-load + no fade (for carousels where lazy/fade flickers)
}) => {
    const [loaded, setLoaded] = useState(false);
    const imgRef = useRef(null);

    const optimizedSrc = useLambdaImage(src, width, quality);

    const objectFitClass = objectFit === 'contain' ? 'object-contain' : 'object-cover';

    const markLoaded = () => {
        setLoaded(true);
        if (onLoad) onLoad();
    };

    // Reset on src change, but immediately reveal images that are already
    // decoded in cache, their `onLoad` may have fired before this handler was
    // attached, which otherwise leaves them stuck at opacity-0 until a remount.
    useEffect(() => {
        const img = imgRef.current;
        if (img && img.complete && img.naturalWidth > 0) {
            markLoaded();
        } else {
            setLoaded(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [optimizedSrc]);

    return (
        <div className={`relative overflow-hidden ${wrapperClassName}`.trim()}>
            {useSekeleton && (
                <div className={`absolute inset-0 transition-opacity duration-500 ease-in-out ${loaded ? 'opacity-0' : 'opacity-100'}`}>
                    <SkeletonImage />
                </div>
            )}

            <img
                ref={imgRef}
                src={optimizedSrc}
                alt={alt}
                onLoad={markLoaded}
                loading={eager ? 'eager' : 'lazy'}
                className={`w-full h-full ${objectFitClass} ${eager ? '' : 'transition-opacity duration-700 ease-in-out'} ${(loaded || eager) ? 'opacity-100' : 'opacity-0'} ${className}`.trim()}
            />
        </div>
    );
};

export default Image;
